module.exports = require("./../../_gen/starling/utils/MathUtil");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/utils/MathUtil.js
// module id = 245
// module chunks = 0